module.exports = __webpack_public_path__ + "static/img/logo.a542a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 8